import { render } from "./AppSocialLinks.vue?vue&type=template&id=c7221170"
import script from "./AppSocialLinks.vue?vue&type=script&lang=js"
export * from "./AppSocialLinks.vue?vue&type=script&lang=js"
script.render = render

export default script